import Vue from 'vue'
import Router from 'vue-router'
import Introduction from '@/components/Introduction'
import SampleData from '@/components/SampleData'
import NotFound from '@/components/NotFound'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/:dataset([^/0-9]+?)',
      name: 'introduction',
      component: Introduction
    },
    {
      path: '/:dataset([^/0-9]+?)/introduction',
      name: 'introduction',
      component: Introduction
    },
    {
      path: '/:dataset([^/0-9]+?)/sample-data',
      name: 'sample-data',
      component: SampleData
    },
    {
      path: '/404',
      component: NotFound
    },
    {
      path: '*',
      component: NotFound
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js